import { Base } from "./colorList.base";
import { Color } from "./components/color/color";
import { Family } from "./components/family/family";

export const ColorList = Object.assign(Base, {
    Family: Family,
    Color: Color
});
